const STATUS_STYLE = {
  "Aguardando espelho": { bg: "#FFFBEE", border: "#FCE6A3", text: "#9A6B0A" },
  "Aguardando GDV": { bg: "#FFFBEE", border: "#FCE6A3", text: "#9A6B0A" },
  "GDV em Andamento": { bg: "#EAF7EF", border: "#BFDBFE", text: "#1D4ED8" },
  "Coleta solicitada": { bg: "#EAF7EF", border: "#BFDBFE", text: "#1D4ED8" },
  "Insucesso de coleta": { bg: "#FEF2F2", border: "#FECACA", text: "#B91C1C" },
  "Em trânsito": { bg: "#F5F3FF", border: "#DDD6FE", text: "#6D28D9" },
  "Entregue": { bg: "#F0FDF4", border: "#BBF7D0", text: "#15803D" },
  "Finalizado": { bg: "#ECFDF5", border: "#A7F3D0", text: "#047857" },
};

export const STATUS_FLOW = Object.keys(STATUS_STYLE);

export default function StatusBadge({ status }) {
  const s = STATUS_STYLE[status] || { bg: "#F3F4F6", border: "#E5E7EB", text: "#4B5563" };
  return (
    <span
      data-testid={`status-badge-${(status || "").toLowerCase().replace(/\s+/g, "-")}`}
      className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold border whitespace-nowrap"
      style={{ backgroundColor: s.bg, borderColor: s.border, color: s.text }}
    >
      {status}
    </span>
  );
}
